import { useQuery } from '@tanstack/react-query';
import { fetchSegregacaoDetalhar } from '../api/SegregacaoApi';
import type { SegregacaoDetalharPayload } from '../api/types';

export function useSegregacaoDetalhar(payload: SegregacaoDetalharPayload | null) {
  return useQuery({
    queryKey: [
      'segregacao-detalhar',
      payload?.CNPJ_Contribuinte,
      payload?.Ano,
      payload?.Mes,
      payload?.LinhaSegregada,
    ],
    queryFn: () => fetchSegregacaoDetalhar(payload!),
    enabled: !!payload,
    staleTime: 60_000,
  });
}
